<template>
  <div class="app-wrapper">
      <app-main />
  </div>
</template>

<script>

import AppMain from "./components/AppMain";
export default {
  name: "Layout",
  components: {AppMain},
  methods: {},
};
</script>

<style lang="scss" scoped>


.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
